import { N900 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CenterJustifiedContainer } from './center-justified-container';
import { PriceDisplay } from './price-display';

export type FreeProps = {
  formattedZeroPrice: string;
  fontSize: string;
  planName: string;
};

export const Free = ({ planName, formattedZeroPrice, fontSize }: FreeProps) => (
  <>
    <PriceDisplay
      planName={planName}
      formattedPrice={formattedZeroPrice}
      fontSize={fontSize}
    />
    <CenterJustifiedContainer>
      <PriceDesc>
        <FormattedMessage
          id="freePlanDescLine1"
          defaultMessage="Always free for 10 users,"
          description="Free plan description first line."
        />
      </PriceDesc>
      <MonthlyDesc>
        <FormattedMessage
          id="freePlanDescLine2"
          defaultMessage="monthly subscription only"
          description="Free plan description second line."
        />
      </MonthlyDesc>
    </CenterJustifiedContainer>
  </>
);

const PriceDesc = styled.div`
  font-size: 16px;
  line-height: 24px;
`;

const MonthlyDesc = styled.div`
  color: ${N900};
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 32px;
`;
